const huTranslation = {
  common: {
    close: 'Bezárás',
    flagCaution: 'Érzékeny téma. Ellenőrizd alaposan ezt a választ.',
    flagInfo: 'Jó tudni.',
    welcome: 'Üdvözlünk',
    login: 'Bejelentkezés',
    logout: 'Kijelentkezés',
    send: 'Küldés',
    stop: 'Leállítás',
    retry: 'Újrapróbálás',
    loading: 'Betöltés...',
    error: 'Hiba',
    success: 'Sikeres',
    cancel: 'Mégse',
    confirm: 'Megerősítés',
    typeToFilter: 'Gépelj a szűréshez…',
    save: 'Mentés',
    language: 'Nyelv',
    newChat: 'Új beszélgetés',
    startingNewChat: 'Új beszélgetés indítása...',
    searchMessage: 'Gondolkodom és elemzem a releváns információkat...',
    searchMessageTiming: 'Munkautasítások és tudáselemek átvizsgálása...',
    tryAgain: 'Próbáld újra',
    back: 'Vissza',
    enabled: 'Bekapcsolva',
    disabled: 'Kikapcsolva',
    goBack: 'Vissza',
    attachDocument: 'Dokumentum csatolása',
    aiDisclaimer: 'A válaszokat mesterséges intelligencia generálja. A fontos információkat mindig ellenőrizd hivatalos forrásokon keresztül.',
    copyAnswer: 'Válasz másolása',
    copyMessage: 'Üzenet másolása',
    copied: 'Másolva!',
    copyToClipboard: 'Másolás a vágólapra',
    expand: 'Kibontás',
    minimize: 'Kicsinyítés',
    showMore: 'Több megjelenítése',
    noInternalKnowledge: 'Nem található belső tudás',
    noAdditionalResponse: 'Nincs további válasz',
    // Dual answer UX
    swapMessage: 'Találtunk egy cégspecifikus választ. Az általános válasz továbbra is elérhető alább.',
    toggleShowGeneral: 'Általános válasz megjelenítése (ChatGPT)',
    toggleHideGeneral: 'Általános válasz elrejtése',
    progressExternal: 'Keresés a ChatGPT-vel…',
    progressInternal: 'Keresés a céges tudásban…',
    internalError: 'A céges tudás jelenleg nem elérhető.',
    promoteSecondary: 'Használat fő válaszként',
    compareAnswers: 'Válaszok összehasonlítása egymás mellett',
    switchBack: 'Visszaváltás',
    generalInformation: 'ChatGPT',
    internalGuidelines: 'Belső irányelvek',
  },
  // Retrieval-step labels, keyed by graph tool prefix. A per-source key
  // (`tools.graph_search_<key>.done`) overrides these when one is defined.
  tools: {
    graph_search: {
      active: 'Keresés a tudásgráfban…',
      done: 'Tudásgráf átkutatva',
    },
    ask_clarification: {
      active: 'Pontosító kérdés összeállítása…',
      done: 'Pontosító kérdés feltéve',
    },
    unknown: {
      active: '{{name}} folyamatban…',
      done: '{{name}} befejeződött',
    },
    statusDone: 'Kész',
    statusRunning: 'Folyamatban…',
  },
  clarification: {
    escapeHatchLabel: 'Saját válasz beírása',
    skip: 'Kihagyás',
    submit: 'Küldés',
    nextQuestion: 'Következő kérdés',
    previousQuestion: 'Előző kérdés',
    selectAllThatApply: '(Jelölje meg az összes megfelelőt)',
    stepCounter: '{{current}} / {{total}}',
    selectedCount: '{{count}} kijelölve',
    selectOption: '{{label}} kijelölése',
    deselectOption: '{{label}} kijelölésének törlése',
    shortcutHint: '↑↓ navigálás · Enter kijelölés · Shift+Enter küldés · Esc kihagyás',
  },
  knowledge_source: {
    badge_ai: 'MI',
    badge_internal: 'Vállalati adatok',
    badge_internet: 'Internet',
  },
  errors: {
    assistantResponseContentViolation:
      'Az asszisztens válasza sérti a tartalmi irányelveinket. Kérjük, próbáld újra, vagy fogalmazd át a kérdésedet.',
    userInputContentViolation:
      'A kérésed olyan tartalmat tartalmaz, amely sérti a tartalmi irányelveinket. Kérjük, fogalmazd át a kérdésedet.',
    llmProviderUserInputBlocked:
      'Az üzenetedet az MI-szolgáltató tartalomszűrője blokkolta. Kérjük, fogalmazd át a kérdésedet.',
    llmProviderBotResponseBlocked:
      'Az MI válaszát a szolgáltató tartalomszűrője blokkolta. Kérjük, próbáld újra, vagy fogalmazd át a kérdésedet.',
    llmProviderApiError: 'Problémákat tapasztalunk az MI-szolgáltatásunkkal. Kérjük, próbáld újra később.',
    modelRateLimited:
      'Az MI-modell éppen le van terhelve. Kérjük, próbáld újra — ha továbbra is terhelt, egy másik modell válaszol.',
    modelTimeout: 'Az MI-modell túl sokáig válaszolt. Kérjük, próbáld újra.',
    modelUnavailable:
      'Az MI-modell jelenleg nem érhető el. Kérjük, próbáld újra — egy másik modell fog válaszolni.',
    serverError: 'Váratlan szerverhiba történt. Kérjük, próbáld újra, vagy fordulj az ügyfélszolgálathoz, ha a probléma továbbra is fennáll.',
    agentNotFound: 'A keresett asszisztens nem létezik, vagy már nem elérhető.',
    conversationNotFound: 'A keresett beszélgetés nem létezik, vagy már nem elérhető.',
    noAccessScopes:
      'Jelenleg nincs hozzáférésed egyetlen tudásforráshoz sem. A hozzáférés igényléséhez hozz létre egy support jegyet, vagy fordulj az IT-rendszergazdádhoz.',
    noAccessScopesWithEmail:
      'Jelenleg nincs hozzáférésed egyetlen tudásforráshoz sem. A hozzáférés igényléséhez hozz létre egy support jegyet, vagy fordulj az IT-ügyfélszolgálathoz a következő címen: {{email}}.',
    startViolatedPoliciesList: 'A következő irányelvek sérültek',
    questionTooLong: {
      title: 'A kérdésed túl hosszú',
      description: 'A maximális hossz 30 000 karakter.',
    },
    excelNotSupportedYet: {
      title: 'Az Excel és CSV támogatás hamarosan érkezik!',
      description:
        'Dolgozunk az Excel- és CSV-fájlok támogatásán, amely hamarosan elérhető lesz. Egyelőre kérjük, használj PDF- vagy Word-fájlokat.',
    },
    internetSearchNotWaiting: 'Erre a keresésre már válaszoltál, például egy másik lapon. Frissítsd az oldalt az eredmény megtekintéséhez.',
  },
  auth: {
    welcomeTester: 'Üdvözlünk, kolléga',
    welcomeMessage: 'Üdvözlünk a {{assistantName}} asszisztensnél!',
    loginWithMicrosoft: 'Bejelentkezés Microsoft-fiókkal',
    loginInstructions: 'Jelentkezz be a Microsoft-fiókoddal a kezdéshez.',
    welcomeCompany: 'Üdvözlünk itt: {{companyName}}!',
    loginWithPassword: 'Bejelentkezés felhasználónévvel és jelszóval',
    hidePasswordForm: 'Elrejtés',
    login: 'Bejelentkezés',
  },
  chat: {
    placeholder: 'Tedd fel itt a kérdésedet',
    thinking: 'Gondolkodom...',
    anonymousUser: 'Névtelen',
    howToAskGoodQuestion: 'Hogyan tegyél fel jó kérdést?',
    askQuestion: 'Tedd fel a kérdésedet',
    exampleQuestions: 'Példakérdések',
    tryAsking: 'Próbáld megkérdezni:',
    assistant: '{{assistantName}}, a te digitális asszisztensed',
    welcomeMessage:
      'Szia {{name}}! {{assistantName}} vagyok, a te digitális asszisztensed. Segíthetek a munkautasításokkal és tudáselemekkel kapcsolatos kérdésekben. Mit szeretnél tudni?',
    loading: 'Beszélgetés betöltése...',
    timingKnowledge: 'TIPP',
    chatgpt: 'ChatGPT',
    internet: 'Internet',
    serverError: 'Váratlan szerverhiba történt. Kérjük, próbáld újra, vagy fordulj az ügyfélszolgálathoz, ha a probléma továbbra is fennáll.',
    disclaimerText: 'MI által generált válaszok. Ezekből a válaszokból semmilyen jog nem származtatható.',
    dropFilesHere: 'Húzd ide a fájlokat a beszélgetéshez való hozzáadáshoz',
    addMenu: 'Hozzáadás',
    addFiles: 'Fájl hozzáadása',
    knowledgeSourceOff: '{{name}} kikapcsolva',
    filteredTo: 'Szűrve erre',
    talkingTo: 'Beszélgetőpartner: {{name}}',
    leaveAgent: 'Kilépés: {{name}}',
    askAgain: 'Kérdezz másik asszisztenst',
    askAgent: 'Kérdezd meg: {{name}}',
    filters: 'Szűrők',
    filtersInfo: 'A csevegést adott szűrőkre korlátozza.',
    unsupportedFileType: 'A fájltípus nem támogatott',
    uploadingFile: 'Fájl feltöltése…',
    uploadLimit: 'Legfeljebb {{max}} fájl, egyenként legfeljebb 10 MB',
    fileTooLarge: 'A fájl mérete nem haladhatja meg a 10 MB-ot',
    fileTypeNotAllowed: 'Csak PDF-, Word-, Excel-, PowerPoint- (PPTX), CSV- és TXT-fájlok engedélyezettek',
    fileTypeNotAllowedWithImages:
      'Csak PDF-, Word-, Excel-, PowerPoint- (PPTX), CSV-, TXT- és képfájlok (PNG, JPEG, WEBP) engedélyezettek',
    documentUploadFailed: 'A dokumentum feltöltése sikertelen',
    tooManyFiles: 'Üzenetenként legfeljebb {{max}} fájlt csatolhatsz',
    attachmentsNotReady: 'Várd meg, amíg minden fájl feltöltődik, vagy távolítsd el a sikerteleneket',
    retryAttachment: '{{name}} feltöltésének újrapróbálása',
    removeAttachment: '{{name}} eltávolítása',
  },
  answerStatus: {
    checking: 'Keresőkifejezések ellenőrzése…',
    internet: 'Keresés az interneten: {{query}}',
    knowledge: 'Keresés a vállalati adatokban: {{query}}',
    document: 'A dokumentumod olvasása…',
    files_one: 'Fájl feldolgozása: {{name}}',
    files_other: '{{count}} fájl feldolgozása…',
    image: 'A kép megtekintése…',
    imageNamed: 'A kép megtekintése: {{name}}',
    slowFiles: 'A sok képet tartalmazó nagy fájlok feldolgozása néhány percig is eltarthat…',
  },
  internetSearch: {
    badgeLabel: 'Internetes keresés',
    queriesSent_one: '{{count}} keresőkifejezés elküldve',
    queriesSent_other: '{{count}} keresőkifejezés elküldve',
    badgeTooltip: 'Ez az asszisztens tud az interneten keresni',
    approval: {
      queryTooLong: 'Rövidítsd le a keresőkifejezést legfeljebb 500 karakterre.',
      title: 'Engedélyezed az internetes keresést?',
      descriptionOne: 'Ez a keresőkifejezés az internetre kerül, és bizalmas adatokat tartalmazhat (kiemelve). Módosítsd, vagy küldd el így.',
      descriptionMany: 'Ezek a keresőkifejezések az internetre kerülnek, és bizalmas adatokat tartalmazhatnak (kiemelve). Módosítsd őket, vagy küldd el így.',
      descriptionUncheckedOne: 'Ez a keresőkifejezés az internetre kerül. Nem tudtuk automatikusan ellenőrizni: nézd át, mielőtt elküldöd.',
      descriptionUncheckedMany: 'Ezek a keresőkifejezések az internetre kerülnek. Nem tudtuk automatikusan ellenőrizni őket: nézd át őket, mielőtt elküldöd.',
      descriptionCleanOne: 'Ez a keresőkifejezés az internetre kerül. Nézd át: módosítsd, vagy küldd el így.',
      descriptionCleanMany: 'Ezek a keresőkifejezések az internetre kerülnek. Nézd át őket: módosítsd őket, vagy küldd el így.',
      queryLabel: 'Keresőkifejezés',
      dropQuery: 'Ne keressen rá',
      dropped: 'Nem lesz keresés rá',
      undrop: 'Mégis keressen',
      sendSearch: 'Keresés indítása',
      useInternal: 'Belső adatok használata',
      continueWithoutInternet: 'Folytatás internet nélkül',
      internalStatus: 'Internetes keresés kihagyva · Belső adatok használata',
      noInternetStatus: 'Internetes keresés kihagyva · Válasz internet nélkül',
      categories: {
        customer: 'ügyfélnév',
        person: 'személy',
        vessel: 'hajó',
        project: 'projekt',
        internal_code: 'belső kód',
        contact: 'elérhetőség',
        financial: 'pénzügyi',
        credential: 'bejelentkezési adatok',
        identifier: 'azonosítószám',
        special_category: 'különleges személyes adatok',
        confidential: 'bizalmas',
        other: 'esetleg bizalmas',
      },
    },
  },
  agentChat: {
    placeholder: 'Írd be a kérdésedet az ügynöknek...',
    welcomeMessage: 'Szia, én vagyok az MI-ügynököd. Hogyan segíthetek ma?',
    privilegedWelcomeMessage: 'Szia {{userName}}! {{description}}',
    startPrompt: 'Tegyél fel egy kérdést a kezdéshez',
  },
  profile: {
    settings: 'Beállítások',
    selectLanguage: 'Válaszd ki a nyelvedet',
    appearance: 'Megjelenés',
    darkMode: 'Sötét mód',
    languageChanged: 'A nyelv megváltozott',
    noEmailAvailable: 'Nincs elérhető e-mail-cím',
    general: 'Általános',
    models: 'Modellek',
    noModelsAvailable: 'Nincsenek elérhető modellek',
    modelSettings: 'Modellbeállítások',
    savingSettings: 'Mentés...',
    settingsUpdateFailed: 'A modellbeállítások mentése nem sikerült. Kérjük, próbáld újra.',
  },
  sidebar: {
    conversations: 'Előzmények',
    assistants: 'Asszisztensek',
    userGuide: 'Felhasználói útmutató',
    chatHistory: 'Beszélgetési előzmények',
    today: 'Ma',
    thisWeek: 'Ezen a héten',
    lastWeek: 'Múlt héten',
    earlier: 'Korábban',
    conversation: 'Beszélgetés',
    noAssistantsAvailable: 'Nincsenek elérhető asszisztensek',
    noContent: 'Nincs tartalom',
    noPreviousConversations: 'Nem találhatók korábbi előzmények',
    searchConversations: 'Előzmények keresése...',
    noSearchResults: 'Nincs a keresésednek megfelelő előzmény',
    favorites: 'Kedvencek',
    noFavorites: 'Nincsenek kedvencek',
    addFavoritesHint: 'Lépj a könyvtárba, hogy asszisztenseket adj a kedvenceid közé.',
    loadingPrivilegedAgents: 'Asszisztensek betöltése...',
    rename: 'Átnevezés',
    conversationActions: 'Beszélgetési műveletek',
    renameConversationError: 'A beszélgetés átnevezése nem sikerült',
  },
  feedback: {
    likeAnswer: 'Válasz kedvelése',
    dislikeAnswer: 'Válasz nemtetszése',
    feedbackSent: 'A visszajelzésedet elküldtük! ✅',
    provideFeedback: 'Adj visszajelzést a kérdésről',
    enterFeedback: 'Írd ide a visszajelzésedet',
    send: 'Küldés',
    assistantFallback: 'MI-asszisztens',
    downvoteDisclaimer:
      'Amikor a küldés gombra kattintasz, az utolsó két üzeneted névtelenül megosztásra kerül elemzés céljából, hogy segítsen a(z) {{assistant}} fejlesztésében.',
    reasons: {
      incorrect: 'A válasz helytelen',
      sourceIncorrect: 'A forrás helytelen',
      other: 'Egyéb...',
    },
  },
  // Generic information pop-out — client-agnostic.
  // Texts are feature-flag driven and use {{companyName}} for the company name.
  informationModal: {
    title: 'A(z) {{companyName}} asszisztensről',
    intro:
      'Üdvözlünk a(z) {{companyName}} asszisztensénél. Az alábbiakban megtudhatod, miben tud segíteni az asszisztens, és hogyan hozhatod ki belőle a legtöbbet.',
    capabilitiesTitle: 'Miben tud segíteni az asszisztens?',
    activeVanillaChat:
      'Az asszisztens olyan kérdésekre tud válaszolni, mint amilyeneket a ChatGPT-nek tennél fel.',
    activeVanillaInactiveWebSearch:
      'Az asszisztens széles körű általános tudással rendelkezik, de nem ismeri az aktuális eseményeket, például a legfrissebb híreket.',
    activeInternalSearch:
      'Az asszisztens belső információforrások egy meghatározott válogatása alapján tud válaszolni a kérdésekre.',
    activeInternetSearch:
      'Az asszisztens képes az interneten keresni, hogy választ adjon az aktuális eseményekkel kapcsolatos kérdésekre.',
    activeInternetSearchPrivacyWarning:
      'Megjegyzés: az internetes keresésekből származó kérdések és válaszok, akárcsak a szokásos internethasználat, nem teljesen privátak. Ne ossz meg bizalmas céges információkat az internetes keresés használatakor.',
    activeDocumentUpload:
      'Feltölthetsz dokumentumokat, és megbeszélheted azokat az asszisztenssel, például az összefoglalásukhoz vagy a teendők kiemeléséhez.',
    activeAgents:
      'Kiválaszthatsz konkrét <1>asszisztenseket</1>, akikkel beszélgethetsz. Minden asszisztensnek saját utasításai vannak, ezért bizonyos feladatokban jobban teljesít.',
    activeModelSelection:
      'Az üzenet beviteli mezőjében választhatod ki, melyik MI-modell válaszol a kérdésedre. A <1>modellbeállítások oldalon</1> minden modell beállításait módosíthatod, hogy szabályozd, hogyan válaszol.',
    usageTipsTitle: 'Hogyan hozd ki a legtöbbet az asszisztensből',
    askClearQuestions:
      'Tegyél fel egyértelmű kérdést teljes mondatokban. Az egyszavas kulcsszavak gyakran közepes válaszokat eredményeznek; egy teljes mondat megadja az asszisztensnek a szükséges kontextust, hogy jól segíthessen.',
    conversationHistory:
      'Egy beszélgetésen belül az asszisztens emlékszik arra, amit korábban mondtál, így feltehetsz további kérdéseket. Nem érti, mire gondolsz, ha más beszélgetésekből származó információkra hivatkozol.',
    startNewConversation:
      'Indíts új beszélgetést (a bal felső sarokban lévő gombbal), amikor másik témára váltasz, hogy a válaszok pontosak maradjanak.',
    bewareAssistantsNotAgents:
      'Megjegyzés: ez egy MI-asszisztens, nem MI-ügynök. Egyedi feladatokban segít, amikor kéred, például egy e-mail összefoglalásában, de nem hajt végre önállóan további műveleteket, például e-mailek küldését.',
    feedback:
      'Használd a válasz alatti hüvelykujjakat, hogy visszajelzést adj. Ezzel segítesz okosabbá tenni az asszisztenst.',
    dataVisibilityNoticeTitle: 'Adatláthatósági figyelmeztetés',
    bewareDoNotSharePersonalInformation: 'Megjegyzés: ne ossz meg személyes információkat.',
    supportTitle: 'Segítségre van szükséged?',
  },
  library: {
    title: 'Asszisztensek könyvtára',
    subtitle:
      'Fedezd fel és hozd létre az asszisztensek egyedi változatait, amelyek utasításokat, plusz tudást és a képességek bármely kombinációját egyesítik.',
    searchPlaceholder: 'Asszisztensek keresése...',
    createAgent: 'Asszisztens létrehozása',
    createFirstAgent: 'Hozd létre az első asszisztensedet',
    noAgents: 'Nincsenek elérhető asszisztensek',
    noSearchResults: 'Nincs a keresésednek megfelelő asszisztens',
    noDescription: 'Nincs elérhető leírás',
    mainChat: 'Fő beszélgetés',
    active: 'Aktív',
    library: 'Könyvtár',
    of: '/',
    assistants: 'asszisztens',
    clearFilters: 'Szűrők törlése',
    filtersCleared: 'Szűrők törölve',
    all: 'Mind',
    favorites: 'Kedvencek',
    normal: 'Normál',
    privileged: 'Kiemelt',
    noTags: 'Nincsenek címkék',
    agentSelected: 'Asszisztens kiválasztva',
    isNowActive: 'most aktív',
    select: 'Kiválasztás',
    addToFavorites: 'Hozzáadás a kedvencekhez',
    removeFromFavorites: 'Eltávolítás a kedvencekből',
    moreTags: 'további címke',
    editAgent: 'Asszisztens szerkesztése',
  },
  createAgent: {
    title: 'Új asszisztens',
    subtitle: 'Hozz létre egy új MI-asszisztenst a csapatod segítésére',
    saving: 'Mentés...',
    saveAgent: 'Asszisztens mentése',
    basicInfo: 'Alapinformációk',
    classification: 'Besorolás',
    tagsAndCustomization: 'Címkék és testreszabás',
    icon: 'Ikon',
    name: 'Név',
    namePlaceholder: 'Adj nevet az asszisztensnek',
    description: 'Leírás',
    descriptionPlaceholder: 'Írd le, mire képes az asszisztens',
    department: 'Részleg',
    selectDepartment: 'Válassz egy részleget',
    jobCategory: 'Munkakategória',
    selectJobCategory: 'Válassz egy munkakategóriát',
    tags: 'Címkék',
    optional: 'opcionális',
    addNewTag: 'Új címke hozzáadása',
    add: 'Hozzáadás',
    existingTags: 'Meglévő címkék',
    promptTemplate: 'Prompt sablon',
    promptTemplatePlaceholder:
      'Határozd meg, hogyan válaszoljon az asszisztens... (például: Te egy ügyfélszolgálati asszisztens vagy, aki kedvesen és professzionálisan válaszol a következővel kapcsolatos kérdésekre...)',
    fillAllRequiredFields: 'Kérjük, tölts ki minden kötelező mezőt',
    agentCreated: 'Asszisztens létrehozva',
    createdSuccessfully: 'sikeresen létrejött',
    creationError: 'Létrehozási hiba',
    creationErrorDescription: 'Hiba történt az asszisztens létrehozása közben',
    unsavedChanges: 'Nem mentett változások',
    unsavedChangesMessage: 'Olyan változtatásokat hajtottál végre, amelyeket még nem mentettél el. Biztosan vissza szeretnél lépni?',
    manageJobCategories: 'Munkakategóriák kezelése ehhez a részleghez',
    instructions: 'Utasítások',
    instructionsDescription: 'Határozd meg, hogyan viselkedjen és válaszoljon az asszisztensed a felhasználóknak',
    instructionsLabel: 'Utasítások',
    instructionsPlaceholder: 'Te egy segítőkész asszisztens vagy, aki...',
    instructionsHelperText: 'Légy konkrét az asszisztens szerepével, hangnemével kapcsolatban, és azzal, hogyan segítsen a felhasználóknak',
    instructionsMinLength: 'Az utasításoknak legalább 20 karakter hosszúnak kell lenniük',
    tools: 'Eszközök',
    searchTool: 'Keresőeszköz',
    toolsFileSearch: 'Fájlkeresés',
    toolsImageInspection: 'Képellenőrzés',
    toolsKnowledgeSearch: 'Keresés minden tudásforrásban',
    toolsGraphSearch: 'Keresés a tudásgráfban',
    toolsClarification: 'Pontosító kérdések feltevése',
    toolsKnowledgeSource: '{{name}} keresése',
    toolsColumnName: 'Eszköz',
    toolsColumnEnabled: 'Engedélyezve',
    toolsColumnTraced: 'Nyomon követve',
    toolsTopK: 'Dokumentumok keresésenként',
    toolsTopKHelp: 'Hány dokumentumot ad vissza egy tudásbázis-keresés. Hagyja üresen az alapértelmezett értékhez (5). A nagyobb érték szélesebb lefedettséget ad, a kisebb fókuszáltabb választ eredményez.',
    toolsTracedHelp: "Ha az asszisztens nyomkövetési módja 'Eszközök használatakor', akkor ennek az eszköznek a használata névtelenül rögzíti a beszélgetést elemzési célból.",
    toolsInternetSearch: 'Internetes keresés',
    flags: 'Jelzések',
    flagsHelp: 'Válaszd ki, mely jelzéseket adhatja ez az asszisztens. Alapértelmezésben mind érvényes — kapcsold ki azokat, amelyek nem illenek a témájához.',
    flagsColumnName: 'Jelzés',
    flagsColumnSeverity: 'Súlyosság',
    flagsColumnEnabled: 'Érvényes',
    flagsSeverityInfo: 'Információ',
    flagsSeverityWarning: 'Figyelmeztetés',
    flagsSeverityCritical: 'Kritikus',
    tracing: 'Nyomkövetés',
    tracingHelp: 'Szabályozza, hogy az agent belső működése naplózásra kerül-e diagnosztikai célból, és hogyan. Felülírja az eszközalapú beállításokat',
    tracingAlways: 'Be',
    tracingNever: 'Ki',
    tracingToolBased: 'Eszközalapú',
    visibility: 'Láthatóság',
    visibilityHelp: 'Szabályozza, ki láthatja ezt az asszisztenst. A privát asszisztensek csak Ön számára láthatók.',
    visibilityPublic: 'Láthatóvá tétel a kiválasztott ügyfélentitások számára',
    visibilityEntities: 'Ügyfélentitások',
    visibilityEntitiesPlaceholder: 'Válasszon ügyfélentitásokat',
    visibilityEntitiesHelp: 'Az ezen entitások bármelyikéhez rendelt felhasználók láthatják ezt az asszisztenst.',
    routing: 'Fő beszélgetés',
    routingHelp: 'A fő beszélgetés a hozzá illő kérdéseket ennek az asszisztensnek adja át. Az útválasztó az útválasztási leírást és a példakérdéseket olvassa.',
    routingDescription: 'Útválasztási leírás',
    routingDescriptionPlaceholder: 'Mire való: …\nMire nem: …\nPéldák: …',
    routingDescriptionHelp: 'Írd le, mire való ez az asszisztens, és ugyanilyen fontos, mire nem, főleg ott, ahol más asszisztensekkel határos. Azokat a szavakat használd, amelyeket az emberek valóban beírnak, a saját nyelvükön. {{count}}/{{max}} karakter.',
    routingDescriptionTooLong: 'Legfeljebb {{max}} karakter.',
    routingAvailable: 'Elérhető a fő beszélgetésben',
    routingNotReady: 'Útválasztási leírás és legalább {{min}} példakérdés szükséges.',
    routingUseClientContext: 'Vállalati kontextus használata',
    routingUseClientContextHelp: 'A vállalati kontextust (telephelyek, termékek, kultúra) az asszisztens saját utasításai elé helyezi. A saját utasítások élveznek elsőbbséget.',
    featureRequest: 'Funkciókérés',
    deleteAssistant: 'Asszisztens törlése',
    tagsHelp: 'A címkék segítenek rendszerezni és kategorizálni az asszisztensedet',
    exampleQuestions: 'Példakérdések',
    exampleQuestionsHelp: 'Adj hozzá példakérdéseket, amelyekre a felhasználók rákattinthatnak egy beszélgetés elindításához',
  },
  editAgent: {
    title: 'Asszisztens szerkesztése',
    subtitle: 'Módosítsd az MI-asszisztensed beállításait és viselkedését',
    updateAgent: 'Asszisztens frissítése',
    deleteAgent: 'Asszisztens törlése',
    updating: 'Frissítés...',
    deleting: 'Törlés...',
    agentUpdated: 'Asszisztens frissítve',
    updatedSuccessfully: 'sikeresen frissült',
    updateError: 'Frissítési hiba',
    updateErrorDescription: 'Hiba történt az asszisztens frissítése közben. Kérjük, próbáld újra.',
    agentDeleted: 'Asszisztens törölve',
    deletedSuccessfully: 'sikeresen törölve',
    deleteError: 'Törlési hiba',
    deleteErrorDescription: 'Hiba történt az asszisztens törlése közben. Kérjük, próbáld újra.',
    deleteConfirmTitle: 'Asszisztens törlése',
    deleteConfirmMessage: 'Biztosan törölni szeretnéd ezt az asszisztenst? Ez a művelet nem vonható vissza.',
    confirmDelete: 'Igen, törlés',
    loadingAgent: 'Asszisztens részleteinek betöltése...',
    failedToLoad: 'Az asszisztens részleteinek betöltése nem sikerült',
  },
  jobCategory: {
    addNew: 'Kategória hozzáadása',
    name: 'Név',
    nameRequired: 'A kategória neve kötelező',
    enterName: 'Add meg a kategória nevét...',
    create: 'Létrehozás',
    edit: 'Szerkesztés',
    update: 'Frissítés',
    delete: 'Törlés',
    created: 'Kategória létrehozva',
    createdSuccessfully: 'sikeresen létrejött',
    updated: 'Kategória frissítve',
    updatedSuccessfully: 'sikeresen frissült',
    deleted: 'Kategória törölve',
    deletedSuccessfully: 'sikeresen törölve',
    creationError: 'Létrehozási hiba',
    creationErrorDescription: 'Hiba történt a kategória létrehozása közben',
    updateError: 'Frissítési hiba',
    updateErrorDescription: 'Hiba történt a kategória frissítése közben',
    deletionError: 'Törlési hiba',
    deletionErrorDescription: 'Hiba történt a kategória törlése közben',
    deleteError: 'Törlési hiba',
    deleteErrorDescription: 'Hiba történt a kategória törlése közben',
    deleteConfirmTitle: 'Kategória törlése',
    deleteConfirmMessage: 'Biztosan törölni szeretnéd ezt: "{{name}}"?',
    deleteWarning: 'Ez a művelet nem vonható vissza, és érintheti a meglévő ügynököket.',
    warning: 'Figyelmeztetés',
    agentsWillLoseCategory: 'ügynök elveszíti a kategória-hozzárendelését',
  },
  languageNames: {
    en: 'Angol',
    nl: 'Holland',
    de: 'Német',
    fr: 'Francia',
    it: 'Olasz',
    pl: 'Lengyel',
    hu: 'Magyar',
    id: 'Indonéz',
  },
  knowledgeSourceSelector: {
    title: 'Tudásforrások',
    tooltip: 'Válaszd ki, mely tudásforrásokban keressen',
    all: 'Mind',
  },
  countries: {
    nl: 'Hollandia',
    us: 'Amerika',
    hu: 'Magyarország',
    id: 'Indonézia',
  },
  iconSelector: {
    chooseIcon: 'Válassz egy ikont',
  },
  models: {
    optionUnavailable: '{{model}} — átmenetileg nem érhető el',
    modelRateLimited: 'A(z) {{model}} átmenetileg korlátozott. A kérések a következő elérhető modellhez kerülnek.',
    modelUnavailable: 'A(z) {{model}} jelenleg nem érhető el. A kérések másik modellhez kerülnek.',
    fallbackToast: 'Átváltás erre: {{fallbackModel}} — a(z) {{originalModel}} átmenetileg nem érhető el.',
    recommended: 'Ajánlott',
    verifySources: 'Ezt a választ olyan modell írta, amely HR-kérdésekben kevésbé megbízható. Kérjük, ellenőrizd a forrásnál, mielőtt cselekszel.',
    introHeading: 'Modellbeállítások',
    introBody: 'Ezen az oldalon állítod be, hogyan viselkedjen az egyes modellek. Azt, hogy melyik modell kerül használatra egy beszélgetéshez, nem itt választod ki, hanem magában a csevegésben, a beviteli mező mellett, ahová a kérdésedet írod.',
    noConfigurableParameters: 'Nincsenek beállítások ehhez a modellhez',
  },
}

const clientDefaults = {
  fallbackAgentDescription: 'MI-asszisztens céges tudáshoz az AHV International-től.',
}

export default { ...huTranslation, ...clientDefaults }
